<template>
  <div class="ladder">
    <div
      class="ladder-step"
      :class="{ isFilled: value >= step }"
      v-for="step in steps"
      :key="step"
    ></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    steps: {
      type: Number,
      default: 10,
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  }, //,
  //created(){

  //},
  //computed: {

  //},
  //mounted(){

  //},
  //methods: {

  //}
});
</script>

<style lang="scss" scoped>
$color-default: #e1e9f3;
$amount-steps: 20;
$transition-delay: 0.15s;
$transition-duration: 0.7s;

.ladder {
  display: flex;
  height: 16px;
  overflow: hidden;

  &-step {
    flex-grow: 1;
    // background-color: $color-default;
    background-image: linear-gradient(
      to right,
      $color-primary-blue 34%,
      $color-default 66%
    );
    background-size: 300% 100%;
    background-position: right 0;
    transform: skewX(-45deg);
    transition: all $transition-duration ease;

    @for $i from 1 through ($amount-steps) {
      &:nth-child(#{$i}) {
        animation-delay: $i * $transition-delay;
      }
    }

    &.isFilled {
      // background-position: left 0;
      animation-name: fadein;
      animation-duration: $transition-duration;
      animation-timing-function: ease;
      animation-fill-mode: forwards;
    }

    &:nth-child(1) {
      margin-left: -8px;
    }

    &:nth-last-child(1) {
      margin-right: -8px;
    }

    & + & {
      margin-left: 3px;
    }
  }
}

@keyframes fadein {
  from {
    background-position: right 0;
  }
  to {
    background-position: left 0;
  }
}
</style>
